import * as Joi from 'joi';
import { TFunction } from 'react-i18next';
import { PostUnlockAccountFormData } from '../../../api-refactored/auth/usePostUnlockAccount';

const schemaUnlockAccountForm = (t: TFunction) =>
  Joi.object<PostUnlockAccountFormData>({
    accountType: Joi.string()
      .required()
      .messages({ 'string.empty': t('profile->>UnlockAccount.Error.AccountType') }),
    username: Joi.string()
      .required()
      .messages({
        'string.empty': t('profile->>UnlockAccount.Error.USERNAME'),
        'any.required': t('profile->>UnlockAccount.Error.USERNAME'),
      }),
    dateOfBirth: Joi.string()
      .required()
      .messages({
        'string.empty': t('profile->>UnlockAccount.Error.DateOfBirth'),
        'any.required': t('profile->>UnlockAccount.Error.DateOfBirth'),
      }),
  });
export default schemaUnlockAccountForm;
